module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Название блока"},"en":{"title":"Title"}}')
  delete Component.options._Ctor
}
